import React from 'react';

const Dropdown = ({ id, options, title, label, onChange, value, disabled }) => {
  return (
    <div className={`${label ? 'my-[30px]' : ''} w-full`}>
      {label && (
        <div className="mb-2">
          <label htmlFor={id} className="text-sm font-medium text-slate-700">
            {label}:
          </label>
        </div>
      )}
      <select
        id={id}
        className="block w-full h-9 rounded-md border border-slate-200 bg-white text-sm text-slate-700 px-3 pr-9 focus:outline-none focus:ring-2 focus:ring-blue-200 focus:border-blue-400 disabled:opacity-50 disabled:cursor-not-allowed"
        onChange={onChange}
        value={value}
        disabled={disabled}
      >
        {title ? <option value="">{title}</option> : null}
        {options?.map((item, i) => (
          <React.Fragment key={i}>
            {item?.value !== undefined ? (
              <option value={item.value}>{item.label}</option>
            ) : (
              <option value={item}>{item}</option>
            )}
          </React.Fragment>
        ))}
      </select>
    </div>
  );
};

export default Dropdown;
